import {SchemaOptionalType, SchemaType} from "common/flowmaster/types/schema";

export default (type: SchemaOptionalType): SchemaType => {
  return type[0];
};
